import React from 'react';
import { Route, Routes } from 'react-router';
import { CommunicatorPage } from './Communicator/CommunicatorPage';

export const OnboardingPage_URL = '/onboarding';
export const OnboardingPage = () => {
    return (
        <div className="plans-page h-100">
            <Routes>
                <Route path="communicator/*" element={<CommunicatorPage />} />
            </Routes>
        </div>
    );
};
